var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    {
      'is-disabled': _vm.disabled,
      'is-round': _vm.round
    }
  ],attrs:{"type":_vm.nativeType,"disabled":_vm.disabled},on:{"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43fc3cb0","hasScoped":false,"transformToRequire":{"video":"src","audio":"src","embed":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/base/button.vue
// module id = HsWL
// module chunks = 71